import { $themeBreakpoints } from '@themeConfig'
import axios from '@/libs/axios'
import handleError from '@/views/components/errorHandler'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    shipmentCache: {},
    previousDocumentTypes: {},
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    previousDocumentTypes: state => entryCountry => state.previousDocumentTypes[entryCountry] || [],
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_PREVIOUS_DOCUMENT_TYPES(state, { entryCountry, data }) {
      state.previousDocumentTypes = { ...state.previousDocumentTypes, [entryCountry]: data.data }
    },
  },
  actions: {
    async getPreviousDocumentTypes({ commit, getters }, { entryCountry, toast }) {
      const cached = getters.previousDocumentTypes(entryCountry)
      if (cached.length !== 0) {
        return cached
      }

      try {
        const { data } = await axios.get(`/v1/customs/previous-document-types/${entryCountry}`)
        commit('SET_PREVIOUS_DOCUMENT_TYPES', { entryCountry, data })
        return data
      } catch (err) {
        handleError(err, toast, 'Failed to get previous document types')
        throw err
      }
    },
  },
}
